import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../../core';
import { LeadJaCadastrado } from './lead-ja-cadastrado';

@Injectable({
    providedIn: 'root'
})
export class LeadValidacoesHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/lead`;
    }

    /** Obtem o lead já cadastrado através do seu CNPJ/CPF quando houver um */
    getLeadJaCadastrado(idLead: number, cnpjCpf: string, editMode: boolean): Observable<LeadJaCadastrado> {
        // Params
        let params = new HttpParams();
        // ID do Lead
        if (idLead) {
            params = params.append('idLead', idLead.toString());
        }
        // CNPJ/CPF
        if (cnpjCpf) {
            params = params.append('cnpjCpf', cnpjCpf);
        }
        // Edit Mode (Se está editando ou não o lead)
        if (editMode) {
            params = params.append('editMode', editMode.toString());
        }


        return this.customHttp.get<LeadJaCadastrado>(`${this.pathApi}/0/validacoes/jacadastrado`, {params});
    }
}
